import { EventListPresenterState } from "../../../blocks/EventListPresenter/state";
import { Event } from "../../../contracts";
import { BaseDict } from "../../../blocks/EventListPresenter/dict";

export const getFixtureCardProps = (state: EventListPresenterState, event: Event, cms: any, dict: BaseDict) => {
    const config = state.isMiniEventCard ? state.options.dataProvider.cardConfigurationEventView : state.options.dataProvider.cardConfiguration;

    return {
        event,
        markets: state.displayMarkets(event.id),
        isDesktop: state.deviceDetect.isDesktop,
        sport: {
            id: event.sportId,
            config: config[event.sportId] || config[0]
        },
        handlers: {
            eventCard: state.openGameTranspiler.bind(state, event),
            betButton: state.addToSlipTranspiler.bind(state),
            favorites: state.manageFavorites.bind(state, event),
            liveStream: state.openLiveStream.bind(state, event.id),
            statistics: state.openStatTranspiler.bind(state, event.statisticsEventId)
        },
        isFavoritesEnabled: state.provider.isFavoritesEnabled,
        showMLTeamName: cms.ShowTeamNameML,
        showHeadingNames: state.isMiniEventCard ? false : state.shouldHideSubheadings,
        dict,
        showLeagueInEventCard : state.showLeagueInEventCard,
        showOddBtns: state.showOddBtns
    }
}